export const CE_MAX_DOCUMENTS = 10;
export const CE_MAX_FILE_SIZE = 10 * 1024 * 1024;
export const CE_MAX_FILE_NAME = 255;
export const CE_ALLOWED_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'heic', 'heif'];
export const CE_DOCUMENT_ACCEPT =
  '.pdf,.jpg,.jpeg,.png,.heic,.heif,application/pdf,image/jpeg,image/png,image/heic,image/heif';
export const CE_HEIC_EXTENSIONS = ['heic', 'heif'];
export const CE_HEIC_BRANDS = [
  'heic',
  'heix',
  'heim',
  'heis',
  'hevc',
  'hevx',
  'hevm',
  'hevs',
  'mif1',
  'msf1',
];
export const CE_HEIC_JPEG_QUALITY = 0.8;
export const CE_MIN_MINUTES = 1;
export const CE_MAX_HOURS = 744;
export const CE_MAX_HOURS_PER_DAY = 24;
export const MINUTES_PER_HOUR = 60;
export const CE_MIN_DOLLARS = 0.01;
export const CE_MAX_DOLLARS = 99_999.99;
export const getCeInvalidDuration = (maxHours: number): string =>
  `Enter a duration from 1 minute to ${maxHours} hours.`;
export const CE_INVALID_DURATION = getCeInvalidDuration(CE_MAX_HOURS);
export const CE_INVALID_HOURS = 'Enter a whole number of hours.';
export const CE_INVALID_MINUTES = 'Enter minutes from 0 to 59.';
export const CE_INVALID_DOLLARS = 'Enter an amount from 0.01 to 99,999.99.';
export const CE_INVALID_NUMBER = 'Enter a number';
export const CE_INVALID_CENTS = 'Use up to 2 decimal places';
export const CE_MAX_COMMENT = 2000;
export const CE_COMMENT_TOO_LONG = `The field must be a string with a maximum length of ${CE_MAX_COMMENT}.`;
export const CE_ENGAGEMENT_DATE_IN_FUTURE = "Engagement date can't be in the future";
export const CE_ENGAGEMENT_END_BEFORE_START = "End date can't be before the start date";
export const CE_EXPIRATION_BEFORE_EFFECTIVE =
  'Exemption Expiration Date must be after the Exemption Effective Date.';
